import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { FileText, UserCheck } from 'lucide-react';
import { RegistrationsSection } from './RegistrationsSection';
import { AccountApprovalsSection } from './AccountApprovalsSection';

interface Registration {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  course: string;
  status: 'pending' | 'approved' | 'rejected';
  created_at: string;
}

interface ApplicationsSectionProps {
  registrations: Registration[];
  updateRegistrationStatus: (id: string, status: 'pending' | 'approved' | 'rejected') => Promise<boolean>;
  deleteRegistration: (id: string) => Promise<boolean>;
}

export const ApplicationsSection = ({ 
  registrations, 
  updateRegistrationStatus, 
  deleteRegistration 
}: ApplicationsSectionProps) => {
  return (
    <Card className="border-border/70 bg-card/80 backdrop-blur-sm">
      <CardHeader className="px-4 sm:px-6">
        <CardTitle className="text-foreground flex items-center gap-2">
          <FileText className="h-5 w-5 text-primary" />
          Դիմումների կառավարում
        </CardTitle>
      </CardHeader>
      <CardContent className="px-4 sm:px-6">
        <Tabs defaultValue="registrations" className="w-full">
          <div className="-mx-1 overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          <TabsList className="inline-flex h-auto min-w-max gap-1 border border-border/70 bg-muted/70 p-1.5 sm:grid sm:w-full sm:min-w-0 sm:grid-cols-2">
            <TabsTrigger 
              value="registrations"
              className="min-h-11 shrink-0 rounded-md px-3 text-xs text-muted-foreground data-[state=active]:bg-primary data-[state=active]:text-primary-foreground sm:px-2 sm:text-sm"
            >
              <FileText className="h-4 w-4 mr-2" />
              Գրանցումներ
            </TabsTrigger>
            <TabsTrigger 
              value="approvals" 
              className="min-h-11 shrink-0 rounded-md px-3 text-xs text-muted-foreground data-[state=active]:bg-primary data-[state=active]:text-primary-foreground sm:px-2 sm:text-sm"
            >
              <UserCheck className="h-4 w-4 mr-2" />
              Հաստատումներ
            </TabsTrigger>
          </TabsList>
          </div>
          
          <TabsContent value="registrations" className="mt-4">
            <RegistrationsSection 
              registrations={registrations} 
              updateRegistrationStatus={updateRegistrationStatus} 
              deleteRegistration={deleteRegistration} 
            />
          </TabsContent>
          
          <TabsContent value="approvals" className="mt-4">
            <AccountApprovalsSection />
          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  );
};